import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SelfDiagnosisModel } from './model';

export const adapter: EntityAdapter<SelfDiagnosisModel> = createEntityAdapter<SelfDiagnosisModel>({
  selectId: model => model.id,
});

export interface SelfDiagnosisState extends EntityState<SelfDiagnosisModel> {
  selected: SelfDiagnosisModel;
  isLoading?: boolean;
  error?: any;
}

export const initialState: SelfDiagnosisState = adapter.getInitialState({
  selected: null,
  isLoading: false,
  error: null,
});
